import gql from 'graphql-tag'

export const GET_PROVINCES =  gql`
{
    getProvinces {
      _id
      name
      districts {
        _id
        name
        enName
      }
    }
  }
`

